angular
   .module('admin.customers', [])
   .controller(
      'EditCustomerModalCtrl',
      function ($uibModalInstance, ChangeCustomerCredentialsResource, $http, config, RemovalReasons, customer) {
         this.statusValues = [
            {label: 'Novo', value: 'NEW'},
            {label: 'Ativado', value: 'ACTIVATED'},
            {label: 'Suspenso', value: 'SUSPENDED'},
         ]

         // Cria as opções do dropdown de motivo de suspensão baseado nos labels
         this.removalReasons = [
            {label: 'Selecione', value: null},
            {label: RemovalReasons.labels.EXIT_FROM_COMPANY, value: 'EXIT_FROM_COMPANY'},
            {label: RemovalReasons.labels.DEPARTMENT_CHANGE, value: 'DEPARTMENT_CHANGE'},
            {label: RemovalReasons.labels.USER_REPLACEMENT, value: 'USER_REPLACEMENT'},
            {label: RemovalReasons.labels.ACCESS_CHANGE, value: 'ACCESS_CHANGE'},
            {label: RemovalReasons.labels.LICENSES_REDUCTION, value: 'LICENSES_REDUCTION'},
         ]

         this.customer = customer
         this.customerEdit = angular.copy(customer)
         this.customerEdit.cpf = _.padStart(this.customerEdit.cpf, 11, '0')

         // Garante que metadata seja copiado corretamente
         if (customer.metadata && !this.customerEdit.metadata) {
            this.customerEdit.metadata = angular.copy(customer.metadata)
         }

         // Verifica se o usuário já tem um motivo de suspensão setado (não permite editar)
         var originalRemovalReason =
            customer.removalReason || (customer.metadata && customer.metadata.removalReason) || null
         this.hasRemovalReasonSet = !!originalRemovalReason

         // Carrega o removalReason se existir (pode estar em removalReason ou metadata.removalReason)
         // Verifica primeiro no customer original, depois no customerEdit
         // Normaliza o valor para garantir que seja um código válido
         var rawRemovalReason =
            customer.removalReason ||
            (customer.metadata && customer.metadata.removalReason) ||
            this.customerEdit.removalReason ||
            (this.customerEdit.metadata && this.customerEdit.metadata.removalReason) ||
            null

         if (rawRemovalReason) {
            // Converte label para código se necessário
            var normalizedCode = RemovalReasons.getCode(rawRemovalReason)
            this.customerEdit.removalReason = normalizedCode
            // Armazena o código original para garantir que seja mantido
            this.originalRemovalReasonCode = normalizedCode
         } else {
            this.customerEdit.removalReason = null
            this.originalRemovalReasonCode = null
         }

         if (this.customerEdit.status) {
            this.customerEdit.status = this.customerEdit.status.toUpperCase()
         }

         this.onStatusChange = function () {
            if (this.customerEdit.status !== 'SUSPENDED') {
               // Só limpa se não tiver motivo já setado
               if (!this.hasRemovalReasonSet) {
                  this.customerEdit.removalReason = null
               }
            } else if (this.customerEdit.status === 'SUSPENDED' && this.hasRemovalReasonSet) {
               // Se voltar para SUSPENDED e tiver motivo setado, restaura o valor original
               if (this.originalRemovalReasonCode) {
                  this.customerEdit.removalReason = this.originalRemovalReasonCode
               }
            }
         }

         this.cancel = function () {
            $uibModalInstance.dismiss()
         }

         this.save = function () {
            // Se o status for SUSPENDED e não tiver motivo setado no banco, usar o endpoint específico de suspend
            if (this.customerEdit.status === 'SUSPENDED' && !this.hasRemovalReasonSet) {
               if (!this.customerEdit.removalReason || this.customerEdit.removalReason === null) {
                  this.alerts = [
                     {
                        message: 'Motivo da suspensão é obrigatório',
                        type: 'danger',
                     },
                  ]
                  return
               }

               // Garante que o removalReason seja uma string válida
               var removalReason = String(this.customerEdit.removalReason).trim()
               if (!removalReason) {
                  this.alerts = [
                     {
                        message: 'Motivo da suspensão é obrigatório',
                        type: 'danger',
                     },
                  ]
                  return
               }

               $http({
                  method: 'DELETE',
                  url:
                     config.api +
                     '/api/v1/backoffice-user-management/subordinates/' +
                     this.customer.id +
                     '/suspend?lang=pt-BR',
                  headers: {
                     'Content-Type': 'application/json',
                  },
                  data: {
                     removalReason: removalReason,
                  },
                  transformRequest: function (data) {
                     return angular.toJson(data)
                  },
               }).then(
                  () => {
                     this.customer.status = this.customerEdit.status
                     $uibModalInstance.close()
                  },
                  (err) => {
                     this.alerts = [
                        {
                           message: err.data && err.data.message ? err.data.message : 'Erro ao suspender usuário',
                           type: 'danger',
                        },
                     ]
                  },
               )
            }

            // Para outros status, usar o endpoint normal de atualização
            var payload = {
               cpf: this.customerEdit.cpf.replace(/\D/g, ''), // Remove non-digits
               email: this.customerEdit.email,
            }

            if (this.customerEdit.status) {
               payload.status = this.customerEdit.status.toUpperCase()
            }

            if (this.customerEdit.password) {
               payload.password = this.customerEdit.password
            }

            ChangeCustomerCredentialsResource.update(
               {id: this.customer.id},
               payload,
               () => {
                  this.customer.email = this.customerEdit.email
                  this.customer.cpf = Number(this.customerEdit.cpf.replace(/\D/g, ''))
                  this.customer.status = this.customerEdit.status
                  $uibModalInstance.close()
               },
               (err) => {
                  this.alerts = [
                     {
                        message: err.data.message,
                        type: 'danger',
                     },
                  ]
               },
            )
         }
      },
   )
